import React, { useRef, useEffect } from "react";
import Chart from "chart.js/auto";

interface MultiBarChartProps {
  earning_data: any;
}

const MultiBarChart = ({ earning_data }: MultiBarChartProps) => {
  const chartRef = useRef<HTMLCanvasElement>(null);
  const chartInstanceRef = useRef<Chart | null>(null);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      if (ctx) {
        // Destroy previous chart instance if it exists
        if (chartInstanceRef.current) {
          chartInstanceRef.current.destroy();
        }

        chartInstanceRef.current = new Chart(ctx, {
          type: "bar",
          data: {
            labels: earning_data?.graph_labels
              ? earning_data?.graph_labels
              : [
                  "01 Aug",
                  "02 Aug",
                  "03 Aug",
                  "04 Aug",
                  "05 Aug",
                  "06 Aug",
                  "07 Aug",
                ],
            datasets: [
              {
                label: "Plan",
                data: earning_data?.plans_balance,
                backgroundColor: "#EF437B",
                borderColor: "#EF437B",
                borderWidth: 0,
                barPercentage: 0.4,
              },
              {
                label: "Top-up",
                data: earning_data?.top_ups_balance,
                backgroundColor: "#9A469B",
                borderColor: "#9A469B",
                borderWidth: 0,
                barPercentage: 0.4,
              },
            ],
          },
          options: {
            responsive: true,
            scales: {
              x: {
                beginAtZero: true,
                grid: {
                  display: false, // Hide x-axis grid lines
                },
              },
              y: {
                beginAtZero: true,
              },
            },
            plugins: {
              legend: {
                display: false, // Hide legend
              },
              tooltip: {
                position: "nearest",
                mode: "index",
                intersect: false,
                callbacks: {
                  title: function (tooltipItems) {
                    return tooltipItems[0].label;
                  },
                  label: function (context) {
                    const dataset = context.dataset;
                    const value = context.raw;
                    return `${dataset.label}: ${value}`;
                  },
                },
                usePointStyle: true,
                caretPadding: 10,
              },
            },
          },
        });
      }
    }

    // Cleanup on component unmount
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, []);

  return <canvas ref={chartRef}></canvas>;
};

export default MultiBarChart;
